import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ProductCarousel from './components/ProductCarousel';
import HeroBanner from './components/HeroBanner';

const HomePage = () => {
  const [ref1, inView1] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref2, inView2] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref3, inView3] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref4, inView4] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref6, inView6] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [ref7, inView7] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [refAbout, inViewAbout] = useInView({ triggerOnce: true, threshold: 0.1 });
  const [refReferences, inViewReferences] = useInView({ triggerOnce: true, threshold: 0.1 });

  const products = [
    {
      name: 'PET Şişe',
      description: 'Sıvı gıda, içecek, temizlik ve kimyasal ürünler için yüksek berraklık ve dayanıklılık',
      image: 'https://public.readdy.ai/ai/img_res/edited_719abb1687cbf4e299a58b1d7bf36eb8_59ed2a87.jpg',
      link: '/products#pet-sise',
      icon: 'ri-drop-line',
    },
    {
      name: 'PET Kavanoz',
      description: 'Bal, reçel, kuruyemiş, sos ve kozmetik ürünleri için şeffaf ve güvenli ambalaj',
      image:
        'https://public.readdy.ai/ai/img_res/8160ae49312274cb54bc8e6ec2d92c97.jpg',
      link: '/products#pet-kavanoz',
      icon: 'ri-archive-line',
    },
    {
      name: 'PET Preform',
      description: 'Şişirme makinelerinde mükemmel performans için homojen yapı ve hassas ölçüler',
      image:
        'https://public.readdy.ai/ai/img_res/edited_c0ec483edae3c6d3a589413816c78409_72c72c0b.jpg',
      link: '/products#pet-preform',
      icon: 'ri-flask-line',
    },
    {
      name: 'PP Kapak',
      description: 'PET şişe ve kavanozlar için sızdırmaz ve dayanıklı kapatma sistemleri',
      image:
        'https://readdy.ai/api/search-image?query=assortment%20of%20polypropylene%20plastic%20bottle%20caps%20closures%20in%20white%20and%20teal%20colors%20neatly%20arranged%20flat%20lay%20on%20white%20surface%20macro%20product%20photography%20showing%20tamper%20evident%20bands%20and%20thread%20details%20packaging%20components%20studio%20lighting%20sharp%20focus&width=420&height=280&seq=pp-cap-carousel-2025-d4&orientation=landscape',
      link: '/products#pp-kapak',
      icon: 'ri-shield-check-line',
    },
  ];

  const features = [
    {
      icon: 'ri-award-line',
      title: 'Avrupa Standartlarında Üretim',
      description: 'Uluslararası kalite standartlarına uygun modern üretim tesisleri',
      color: 'from-teal/10 to-teal/5',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Gıda Temasına Uygun Hammadde',
      description: 'Sağlık ve güvenlik sertifikalı, gıda temasına uygun malzemeler',
      color: 'from-green/10 to-green/5',
    },
    {
      icon: 'ri-truck-line',
      title: 'Hızlı ve Güvenilir Teslimat',
      description: 'Esnek lojistik çözümleri ile zamanında teslimat garantisi',
      color: 'from-navy/10 to-navy/5',
    },
    {
      icon: 'ri-leaf-line',
      title: 'Sürdürülebilir Üretim Anlayışı',
      description: 'Çevre dostu, %100 geri dönüştürülebilir ambalaj üretimi',
      color: 'from-teal/10 to-teal/5',
    },
    {
      icon: 'ri-global-line',
      title: 'Uluslararası İhracat Deneyimi',
      description: '20+ ülkeye başarılı ihracat ve global iş ortaklıkları',
      color: 'from-green/10 to-green/5',
    },
    {
      icon: 'ri-microscope-line',
      title: 'Sürekli Kalite Kontrol',
      description: 'Her üretim aşamasında laboratuvar testleri ve izlenebilirlik',
      color: 'from-navy/10 to-navy/5',
    },
  ];

  const stats = [
    { number: 4000, suffix: '+', label: 'Günlük Üretim Kapasitesi', unit: 'Adet' },
    { number: 4, suffix: '', label: 'Ürün Kategorisi', unit: 'Kategori' },
    { number: 20, suffix: '+', label: 'İhracat Ülkesi', unit: 'Ülke' },
    { number: 99.8, suffix: '%', label: 'Kalite Skoru', unit: 'Başarı' },
  ];

  const process = [
    { step: '01', title: 'Hammadde Seçimi', desc: 'Gıda temasına uygun, sertifikalı malzeme' },
    { step: '02', title: 'Üretim', desc: 'Modern makinelerle hassas üretim' },
    { step: '03', title: 'Kalite Kontrol', desc: 'Laboratuvar testleri ve onay' },
    { step: '04', title: 'Teslimat', desc: 'Güvenli paketleme ve hızlı sevkiyat' },
  ];

  const references = [
    {
      name: 'Dağkurs',
      logo: 'https://www.dagkurs.com/wp-content/uploads/2024/01/WhatsApp-Gorsel-2024-01-05-saat-15.19.43_a4f710bf.jpg',
    },
    {
      name: 'Benli Turşuculuk',
      logo: 'https://www.benlitursuculuk.com/wp-content/uploads/2025/11/logo.png',
    },
    {
      name: 'Kazova Gıda',
      logo: 'https://www.kazovagida.com.tr/images/logo.png',
    },
    {
      name: 'Salkım Gıda',
      logo: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/94836152cb22393df60d24b840bbbb40.png',
    },
    {
      name: 'Mişnamlı',
      logo: 'https://www.misnamli.com/wp-content/uploads/2021/02/zyro-image__1_-removebg-preview-1.png',
    },
    {
      name: 'Özkaleli',
      logo: 'https://static.readdy.ai/image/07f91bd9f2ad3b84149b39a4e0627797/44cac16d2acdf17973898c877046aad7.png',
    },
    {
      name: 'Tokat Şen Yaprak',
      logo: 'https://tokatsenyaprak.com/gallery/ana%20logo.png?ts=1773746635',
    },
    {
      name: 'İkas',
      logo: 'https://cdn.myikas.com/images/theme-images/a26dc97c-3579-40d2-a5bb-d27f5fa7b0b6/image_1080.webp',
    },
    {
      name: 'Sarım Yaprak',
      logo: 'https://www.sarimyaprak.com/wp-content/uploads/2026/03/sarim-yaprak-logo-3.svg',
    },
  ];

  return (
    <div className="min-h-screen bg-white font-poppins">
      <Navbar />

      {/* Hero Section */}
      <HeroBanner />

      {/* About Section */}
      <section ref={refAbout} className="py-16 sm:py-20 lg:py-32 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 lg:gap-20 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={inViewAbout ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
              className="order-2 lg:order-1"
            >
              <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">
                /HAKKIMIZDA
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-navy mt-4 sm:mt-6 mb-6 sm:mb-8 leading-tight">
                Hikayemiz
              </h2>

              {/* Kayan Yazı */}
              <div className="overflow-hidden mb-6 sm:mb-8 -mx-2">
                <motion.div
                  animate={{ x: ['0%', '-50%'] }}
                  transition={{ duration: 18, repeat: Infinity, ease: 'linear' }}
                  className="flex whitespace-nowrap"
                >
                  {[...Array(6)].map((_, i) => (
                    <span key={i} className="inline-flex items-center gap-4 sm:gap-6 px-4 sm:px-6">
                      <span className="text-xl sm:text-2xl lg:text-3xl font-bold tracking-widest text-teal/30 uppercase font-poppins">
                        Sustain.
                      </span>
                      <span className="w-1.5 h-1.5 rounded-full bg-teal/20 inline-block" />
                      <span className="text-xl sm:text-2xl lg:text-3xl font-bold tracking-widest text-navy/20 uppercase font-poppins">
                        Protect.
                      </span>
                      <span className="w-1.5 h-1.5 rounded-full bg-teal/20 inline-block" />
                      <span className="text-xl sm:text-2xl lg:text-3xl font-bold tracking-widest text-teal/30 uppercase font-poppins">
                        Preserve.
                      </span>
                      <span className="w-1.5 h-1.5 rounded-full bg-navy/15 inline-block" />
                    </span>
                  ))}
                </motion.div>
              </div>

              <div className="space-y-4 sm:space-y-6 text-gray-600 text-sm sm:text-base lg:text-lg leading-relaxed">
                <p>
                  <strong className="text-navy">Anadolu Pet Ambalaj</strong> PET ambalaj sektöründe kaliteli,
                  güvenilir ve sürdürülebilir çözümler sunmak amacıyla kurulmuştur. Kurulduğumuz günden bu
                  yana odağımız; yalnızca üretim yapmak değil, iş ortaklarımıza uzun vadeli değer sağlayan çözümler
                  geliştirmek olmuştur.
                </p>
                <p>
                  Üretim tesisimizde, CNC kalıp atölyemiz dahil olmak üzere tüm süreçler kendi bünyemizde yürütülmektedir.
                  Bu entegre yapı sayesinde; tasarımdan seri üretime kadar her aşama kontrol altında tutulur,
                  müşteri taleplerine hızlı ve esnek şekilde yanıt verilir.
                </p>
                <p>
                  Anadolupet olarak, gıda temasına uygun hammaddeler, yüksek kalite standartları ve titiz kalite
                  kontrol süreçleri ile üretim gerçekleştiriyoruz. Ürünlerimiz; gıda, içecek, temizlik, kozmetik ve
                  endüstriyel kullanım alanlarında güvenle tercih edilmektedir. Yerli üretim gücümüz, teknik altyapımız
                  ve deneyimli ekibimizle; yalnızca bugünün değil, geleceğin ambalaj ihtiyaçlarına da çözüm üretmeyi
                  hedefliyoruz. Anadolupet için ambalaj, markaların güvenle taşıdığı bir sorumluluktur.
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 sm:gap-6 mt-8 sm:mt-10">
                <div className="bg-gradient-to-br from-teal/10 to-teal/5 p-4 sm:p-6 rounded-xl lg:rounded-2xl border border-teal/20">
                  <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-teal mb-2">100%</div>
                  <div className="text-gray-700 text-xs sm:text-sm font-medium">Geri Dönüştürülebilir</div>
                </div>
                <div className="bg-gradient-to-br from-navy/10 to-navy/5 p-4 sm:p-6 rounded-xl lg:rounded-2xl border border-navy/20">
                  <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mb-2">-40%</div>
                  <div className="text-gray-700 text-xs sm:text-sm font-medium">Karbon Emisyonu</div>
                </div>
              </div>

              <div className="mt-8 sm:mt-10">
                <Link
                  to="/about"
                  className="inline-flex items-center gap-3 px-8 sm:px-10 py-3 sm:py-4 bg-teal text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-navy hover:shadow-xl hover:transform hover:-translate-y-1 transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  Daha Fazla Bilgi
                  <i className="ri-arrow-right-line text-lg" />
                </Link>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={inViewAbout ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
              className="relative order-1 lg:order-2"
            >
              <div className="relative rounded-2xl lg:rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=beautiful%20transparent%20PET%20plastic%20bottle%20surrounded%20by%20fresh%20green%20leaves%20and%20natural%20plants%20in%20pristine%20forest%20environment%20with%20morning%20sunlight%20rays%20filtering%20through%20trees%20symbolizing%20environmental%20protection%20sustainability%20and%20nature%20conservation%20eco%20friendly%20packaging%20concept%20professional%20photography%20vibrant%20green%20colors%20pure%20natural%20background&width=700&height=600&seq=nature-bottle-eco-001&orientation=portrait"
                  alt="Doğa Dostu PET Ambalaj"
                  className="w-full h-[400px] sm:h-[500px] lg:h-[600px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/10 to-transparent" />
              </div>

              {/* Decorative Elements */}
              <div className="absolute -top-6 -right-6 w-32 h-32 sm:w-40 sm:h-40 bg-gradient-to-br from-teal/30 to-teal/10 rounded-full blur-2xl" />
              <div className="absolute -bottom-6 -left-6 w-32 h-32 sm:w-40 sm:h-40 bg-gradient-to-br from-navy/30 to-navy/10 rounded-full blur-2xl" />

              {/* Floating Badge */}
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={inViewAbout ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-4 sm:px-6 py-3 sm:py-4 rounded-xl shadow-xl border border-teal/20"
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-teal to-teal/80 rounded-full">
                    <i className="ri-leaf-line text-white text-lg sm:text-xl" />
                  </div>
                  <div>
                    <div className="text-navy font-bold text-sm sm:text-base">Çevre Dostu</div>
                    <div className="text-gray-600 text-xs">Sürdürülebilir Üretim</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section ref={ref1} className="py-12 sm:py-16 lg:py-28 bg-gradient-to-b from-white to-gray-50 overflow-hidden">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView1 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">
              /ÜRÜNLER
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6">
              Ambalaj Çözümlerimiz
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Gıda ve endüstriyel sektörlere özel, yüksek kalite standartlarında üretim
            </p>
          </motion.div>

          <ProductCarousel products={products} inView={inView1} />
        </div>
      </section>

      {/* Why AnadoluPet Section */}
      <section ref={ref2} className="py-12 sm:py-16 lg:py-28 bg-white relative overflow-hidden">
        {/* Animated Background Decorations */}
        <motion.div
          animate={{
            x: [0, 30, 0],
            y: [0, -20, 0],
            scale: [1, 1.1, 1],
          }}
          transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
          className="absolute top-20 left-10 w-64 h-64 bg-gradient-to-br from-teal/8 to-green/5 rounded-full blur-3xl pointer-events-none"
        />
        <motion.div
          animate={{
            x: [0, -25, 0],
            y: [0, 30, 0],
            scale: [1, 1.15, 1],
          }}
          transition={{ duration: 15, repeat: Infinity, ease: 'easeInOut' }}
          className="absolute bottom-20 right-10 w-72 h-72 bg-gradient-to-br from-navy/8 to-teal/5 rounded-full blur-3xl pointer-events-none"
        />
        <motion.div
          animate={{
            x: [0, 20, 0],
            y: [0, 15, 0],
          }}
          transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-green/5 to-teal/3 rounded-full blur-3xl pointer-events-none"
        />

        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView2 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <motion.span
              initial={{ opacity: 0, letterSpacing: '0.05em' }}
              animate={inView2 ? { opacity: 1, letterSpacing: '0.2em' } : {}}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="text-teal text-xs sm:text-sm font-semibold uppercase inline-block"
            >
              /NEDEN BİZ
            </motion.span>
            <motion.h2
              initial={{ opacity: 0, y: 20 }}
              animate={inView2 ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.3 }}
              className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6"
            >
              Sektörde Fark Yaratan Değerlerimiz
            </motion.h2>
            <motion.p
              initial={{ opacity: 0, y: 15 }}
              animate={inView2 ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: 0.4 }}
              className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4"
            >
              Modern teknoloji, kalite standartları ve sürdürülebilir üretim anlayışı
            </motion.p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 60, scale: 0.9, rotateX: 10 }}
                animate={inView2 ? { opacity: 1, y: 0, scale: 1, rotateX: 0 } : {}}
                transition={{
                  duration: 0.7,
                  delay: index * 0.12,
                  ease: [0.25, 0.46, 0.45, 0.94],
                }}
                whileHover={{
                  y: -12,
                  scale: 1.03,
                  transition: { duration: 0.4, ease: 'easeOut' },
                }}
                className="relative p-6 sm:p-8 lg:p-10 rounded-2xl lg:rounded-3xl bg-white border border-gray-100 hover:border-teal/30 hover:shadow-2xl transition-colors duration-500 group cursor-pointer overflow-hidden"
              >
                {/* Animated gradient background on hover */}
                <motion.div
                  className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
                />

                {/* Shimmer effect on hover */}
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 overflow-hidden rounded-2xl lg:rounded-3xl">
                  <motion.div
                    animate={{ x: ['-100%', '200%'] }}
                    transition={{ duration: 2, repeat: Infinity, repeatDelay: 1, ease: 'easeInOut' }}
                    className="absolute top-0 left-0 w-1/3 h-full bg-gradient-to-r from-transparent via-white/20 to-transparent skew-x-12"
                  />
                </div>

                {/* Decorative corner circle */}
                <motion.div
                  className="absolute top-0 right-0 w-24 h-24 sm:w-32 sm:h-32 bg-gradient-to-br from-teal/5 to-transparent rounded-full -mr-12 sm:-mr-16 -mt-12 sm:-mt-16"
                  whileHover={{ scale: 2 }}
                  transition={{ duration: 0.6 }}
                />

                {/* Animated bottom accent line */}
                <motion.div
                  initial={{ scaleX: 0 }}
                  animate={inView2 ? { scaleX: 1 } : {}}
                  transition={{ duration: 0.6, delay: 0.5 + index * 0.12 }}
                  className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal via-green to-teal origin-left opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />

                <div className="relative">
                  {/* Animated icon container */}
                  <motion.div
                    whileHover={{
                      scale: 1.15,
                      rotate: 8,
                    }}
                    transition={{ duration: 0.4, ease: 'easeOut' }}
                    className="relative w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 flex items-center justify-center bg-white rounded-xl lg:rounded-2xl shadow-md mb-4 sm:mb-6 overflow-hidden"
                  >
                    {/* Icon glow effect */}
                    <motion.div
                      animate={
                        inView2
                          ? {
                              boxShadow: [
                                '0 0 0px rgba(20, 184, 166, 0)',
                                '0 0 20px rgba(20, 184, 166, 0.3)',
                                '0 0 0px rgba(20, 184, 166, 0)',
                              ],
                            }
                          : {}
                      }
                      transition={{ duration: 3, repeat: Infinity, delay: index * 0.5 }}
                      className="absolute inset-0 rounded-xl lg:rounded-2xl"
                    />
                    <i className={`${feature.icon} text-teal text-2xl sm:text-3xl relative z-10`} />
                  </motion.div>

                  <motion.h3 className="text-lg sm:text-xl font-bold text-navy mb-3 sm:mb-4 group-hover:text-teal transition-colors duration-300">
                    {feature.title}
                  </motion.h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>

                  {/* Animated arrow on hover */}
                  <motion.div
                    initial={{ opacity: 0, x: -10 }}
                    whileHover={{ opacity: 1, x: 0 }}
                    className="mt-4 sm:mt-6 flex items-center gap-2 text-teal text-sm font-semibold opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                  >
                    <span>Detaylı Bilgi</span>
                    <motion.i
                      animate={{ x: [0, 5, 0] }}
                      transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
                      className="ri-arrow-right-line"
                    />
                  </motion.div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Production Process */}
      <section ref={ref3} className="py-12 sm:py-16 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView3 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">
              /ÜRETİM SÜRECİ
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6 leading-tight">
              Kaliteli Üretimin Adımları
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Her aşamada titizlik, her üründe mükemmellik
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {process.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                animate={inView3 ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.6, delay: index * 0.15 }}
                className="relative"
              >
                <div className="text-center">
                  <div className="relative inline-block mb-4 sm:mb-6">
                    <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 flex items-center justify-center bg-gradient-to-br from-teal to-green rounded-full text-white text-3xl font-bold shadow-xl">
                      {item.step}
                    </div>
                    {index < process.length - 1 && (
                      <div className="absolute top-1/2 left-full w-[calc(100%+2rem)] h-0.5 bg-gradient-to-r from-teal to-green/30 hidden lg:block" />
                    )}
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-navy mb-2 sm:mb-3">{item.title}</h3>
                  <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Quality Commitment Section */}
      <section className="py-12 sm:py-16 lg:py-28 bg-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-navy via-navy to-navy/95 rounded-3xl lg:rounded-[2.5rem] overflow-hidden relative">
            <div className="absolute inset-0 opacity-5">
              <div className="absolute top-0 right-0 w-96 h-96 bg-green rounded-full blur-3xl" />
              <div className="absolute bottom-0 left-0 w-96 h-96 bg-teal rounded-full blur-3xl" />
            </div>

            <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center p-8 sm:p-12 lg:p-16">
              <div>
                <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-green/20 backdrop-blur-sm rounded-xl mb-6">
                  <i className="ri-shield-check-line text-green text-3xl sm:text-4xl" />
                </div>
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                  Kalite Taahhüdümüz
                </h2>
                <p className="text-base sm:text-lg text-white/70 leading-relaxed">
                  Anadolupet Ambalaj için kalite; ölçülebilir, izlenebilir ve sürdürülebilir bir süreçtir. Üretilen her
                  ambalaj, belirlenen teknik kriterlere uygunluğu esas alınarak müşteriye sunulur.
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 text-center group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center bg-green/20 rounded-lg mb-4">
                    <i className="ri-line-chart-line text-green text-2xl" />
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">Ölçülebilir</h3>
                  <p className="text-white/70 text-sm">Her üretim aşamasında teknik kriterler</p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 text-center group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center bg-green/20 rounded-lg mb-4">
                    <i className="ri-search-eye-line text-green text-2xl" />
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">İzlenebilir</h3>
                  <p className="text-white/70 text-sm">Parti bazlı kayıt ve takip sistemi</p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 text-center group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center bg-green/20 rounded-lg mb-4">
                    <i className="ri-recycle-line text-green text-2xl" />
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">Sürdürülebilir</h3>
                  <p className="text-white/70 text-sm">Sürekli iyileştirme ve optimizasyon</p>
                </div>

                <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 border border-white/20 hover:bg-white/15 transition-all duration-300 text-center group cursor-pointer">
                  <div className="w-12 h-12 flex items-center justify-center bg-green/20 rounded-lg mb-4">
                    <i className="ri-checkbox-circle-line text-green text-2xl" />
                  </div>
                  <h3 className="text-lg font-bold text-white mb-2">Uygunluk</h3>
                  <p className="text-white/70 text-sm">Teknik kriterlere tam uyum garantisi</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section ref={ref4} className="py-12 sm:py-16 lg:py-28 bg-navy relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div className="absolute top-0 left-0 w-96 h-96 bg-green rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-teal rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inView4 ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16 lg:mb-20"
          >
            <span className="text-green text-xs sm:text-sm font-semibold uppercase tracking-wider">
              /RAKAMLARLA
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white mt-4 sm:mt-6 mb-4 sm:mb-6 leading-tight">
              AnadoluPet'in Gücü
            </h2>
            <p className="text-base sm:text-lg text-white/70 max-w-2xl mx-auto px-4">
              Üretim kapasitemiz ve kalite standartlarımız
            </p>
          </motion.div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={inView4 ? { opacity: 1, scale: 1 } : {}}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="text-center group"
              >
                <div className="bg-white/5 backdrop-blur-sm rounded-2xl lg:rounded-3xl p-6 sm:p-8 lg:p-10 border border-white/10 hover:bg-white/10 hover:border-green/30 transition-all duration-300">
                  <div className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold text-green mb-3 sm:mb-4 group-hover:scale-110 transition-transform duration-300">
                    {stat.number % 1 === 0
                      ? stat.number.toLocaleString('tr-TR')
                      : stat.number.toFixed(1)}
                    {stat.suffix}
                  </div>
                  <div className="text-base sm:text-lg lg:text-xl text-white font-semibold mb-2">
                    {stat.label}
                  </div>
                  <div className="text-xs sm:text-sm text-white/60">{stat.unit}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Factory Image Section */}
      <section ref={ref6} className="py-12 sm:py-16 lg:py-28 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-12 lg:gap-16 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={inView6 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
            >
              <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">
                /TESİSLERİMİZ
              </span>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-6 sm:mb-8">
                Modern Üretim Altyapısı
              </h2>
              <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-6 sm:mb-8">
                Son teknoloji makineler ve otomatik üretim hatlarımızla, günde 4.000+ adet ürün üretim kapasitesine
                sahibiz. Temiz oda standartlarında, hijyenik üretim ortamımızda gıda temasına uygun ambalaj üretimi
                gerçekleştiriyoruz.
              </p>
              <ul className="space-y-3 sm:space-y-4 mb-8 sm:mb-10">
                <li className="flex items-start gap-3 sm:gap-4">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0 bg-green/10 rounded-full mt-1">
                    <i className="ri-check-line text-green text-xs sm:text-sm" />
                  </div>
                  <span className="text-gray-700 text-sm sm:text-base">
                    Otomatik üretim hatları ve robotik sistemler
                  </span>
                </li>
                <li className="flex items-start gap-3 sm:gap-4">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0 bg-green/10 rounded-full mt-1">
                    <i className="ri-check-line text-green text-xs sm:text-sm" />
                  </div>
                  <span className="text-gray-700 text-sm sm:text-base">Temiz oda standartlarında üretim ortamı</span>
                </li>
                <li className="flex items-start gap-3 sm:gap-4">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center flex-shrink-0 bg-green/10 rounded-full mt-1">
                    <i className="ri-check-line text-green text-xs sm:text-sm" />
                  </div>
                  <span className="text-gray-700 text-sm sm:text-base">7/24 kalite kontrol ve izlenebilirlik</span>
                </li>
              </ul>
              <Link
                to="/production-quality"
                className="inline-block px-8 sm:px-10 lg:px-12 py-3 sm:py-4 bg-teal text-white text-sm sm:text-base font-semibold rounded-lg hover:bg-navy hover:shadow-xl transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Üretim Sürecimizi İnceleyin
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={inView6 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
              className="relative"
            >
              <div className="relative rounded-2xl lg:rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20clean%20industrial%20factory%20interior%20with%20PET%20bottle%20production%20machinery%20bright%20white%20and%20teal%20lighting%20professional%20manufacturing%20facility%20high%20tech%20automated%20equipment%20organized%20pristine%20workspace%20industrial%20photography&width=700&height=600&seq=factory-interior-bright-002&orientation=landscape"
                  alt="AnadoluPet Üretim Tesisi"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-navy/20 to-transparent" />
              </div>
              <div className="absolute -bottom-6 sm:-bottom-8 -right-6 sm:-right-8 w-48 h-48 sm:w-64 sm:h-64 bg-gradient-to-br from-green/20 to-teal/20 rounded-full blur-3xl -z-10" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Sustainability CTA */}
      <section
        ref={ref7}
        className="py-16 sm:py-20 lg:py-32 bg-gradient-to-br from-green via-teal to-green-dark relative overflow-hidden"
      >
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" />
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
        </div>

        <div className="relative max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-16 lg:gap-20 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={inView7 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-xl lg:rounded-2xl mb-6 sm:mb-8">
                <i className="ri-leaf-line text-white text-4xl sm:text-5xl" />
              </div>
              <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6 leading-tight">
                Geleceğe Sorumlu<br />
                Üretim Anlayışı
              </h2>
              <p className="text-base sm:text-lg lg:text-xl text-white/90 mb-8 sm:mb-10 leading-relaxed">
                Tüm ürünlerimiz %100 geri dönüştürülebilir malzemeden üretilir. Çevre dostu üretim süreçlerimizle sürdürülebilir
                bir gelecek inşa ediyoruz.
              </p>
              <Link
                to="/sustainability"
                className="inline-block px-8 sm:px-10 lg:px-12 py-4 sm:py-5 bg-white text-green text-sm sm:text-base font-semibold rounded-lg hover:bg-navy hover:text-white hover:shadow-2xl transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                Sürdürülebilirlik Politikamız
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={inView7 ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.8 }}
              className="grid grid-cols-2 gap-4 sm:gap-6"
            >
              <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 sm:p-8 border border-white/20">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-3">100%</div>
                <div className="text-white/90 text-sm sm:text-base">Geri Dönüştürülebilir</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 sm:p-8 border border-white/20">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-3">-40%</div>
                <div className="text-white/90 text-sm sm:text-base">Karbon Emisyonu</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 sm:p-8 border border-white/20">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-3">-60%</div>
                <div className="text-white/90 text-sm sm:text-base">Su Tüketimi</div>
              </div>
              <div className="bg-white/10 backdrop-blur-sm rounded-xl lg:rounded-2xl p-6 sm:p-8 border border-white/20">
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-2 sm:mb-3">-50%</div>
                <div className="text-white/90 text-sm sm:text-base">Enerji Kullanımı</div>
              </div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* References Section */}
      <section
        ref={refReferences}
        className="py-12 sm:py-16 lg:py-24 bg-white overflow-hidden"
      >
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inViewReferences ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            className="text-center mb-10 sm:mb-16"
          >
            <span className="text-teal text-xs sm:text-sm font-semibold uppercase tracking-wider">
              /REFERANSLARIMIZ
            </span>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mt-4 sm:mt-6 mb-4 sm:mb-6">
              Güvenilen Markalarla Çalışıyoruz
            </h2>
            <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
              Dünya çapında tanınmış markaların tercihi
            </p>
          </motion.div>

          {/* Infinite Scroll Animation */}
          <div className="relative">
            <div className="absolute left-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-r from-white to-transparent z-10" />
            <div className="absolute right-0 top-0 bottom-0 w-20 sm:w-32 bg-gradient-to-l from-white to-transparent z-10" />

            <div className="flex overflow-hidden">
              <motion.div
                animate={{
                  x: [0, -1800],
                }}
                transition={{
                  x: {
                    repeat: Infinity,
                    repeatType: 'loop',
                    duration: 30,
                    ease: 'linear',
                  },
                }}
                className="flex gap-8 sm:gap-12 lg:gap-16 pr-8 sm:pr-12 lg:pr-16"
              >
                {[...references, ...references].map((ref, index) => (
                  <div
                    key={index}
                    className="flex-shrink-0 w-40 sm:w-48 lg:w-56 h-24 sm:h-28 lg:h-32 bg-white rounded-xl lg:rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 flex items-center justify-center p-4 sm:p-6 border border-gray-100 group cursor-pointer"
                  >
                    <img
                      src={ref.logo}
                      alt={ref.name}
                      className="max-w-full max-h-full object-contain grayscale group-hover:grayscale-0 transition-all duration-300 opacity-60 group-hover:opacity-100"
                    />
                  </div>
                ))}
              </motion.div>
            </div>
          </div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={inViewReferences ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 mt-12 sm:mt-16 lg:mt-20"
          >
            <div className="text-center p-6 sm:p-8 bg-gradient-to-br from-teal/5 to-teal/10 rounded-xl lg:rounded-2xl border border-teal/20">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-teal mb-2">100+</div>
              <div className="text-gray-700 text-sm sm:text-base font-medium">Mutlu Müşteri</div>
            </div>
            <div className="text-center p-6 sm:p-8 bg-gradient-to-br from-green/5 to-green/10 rounded-xl lg:rounded-2xl border border-green/20">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-green mb-2">20+</div>
              <div className="text-gray-700 text-sm sm:text-base font-medium">İhracat Ülkesi</div>
            </div>
            <div className="text-center p-6 sm:p-8 bg-gradient-to-br from-navy/5 to-navy/10 rounded-xl lg:rounded-2xl border border-navy/20">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-navy mb-2">500+</div>
              <div className="text-gray-700 text-sm sm:text-base font-medium">Tamamlanan Proje</div>
            </div>
            <div className="text-center p-6 sm:p-8 bg-gradient-to-br from-teal/5 to-teal/10 rounded-xl lg:rounded-2xl border border-teal/20">
              <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-teal mb-2">99.8%</div>
              <div className="text-gray-700 text-sm sm:text-base font-medium">Müşteri Memnuniyeti</div>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
